export default ({ga, contrastClass, ariaLabel, iconClass, text, iconAnimationClasses, ariaPressed}) => `
<button ${ga ? `data-ga-track="wishlist" data-ga-mediaID="${ga.mediaId}" data-ga-type=${ga.formatType}` : ''}
class="WishListButton ${contrastClass}" 
type="button" 
aria-label="${ariaLabel}"
aria-pressed="${ariaPressed}">
    <i class="${iconClass} icon ${iconAnimationClasses}" aria-hidden="true"></i>
    ${text ? `<span class="u-allCaps WishListButton-text">${text}</span>` : ''}
</button>`;
